import { useOrganization } from 'hooks/store';

export default function useCostCodeEnabled() {
  const { trackCostCode } = useOrganization();
  return !!trackCostCode;
}
